import { Core } from "@faire/design-tokens";
import styled, { css } from "styled-components";

export const ZoomImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 1000ms cubic-bezier(0.17, 0.67, 0.24, 1);
`;

export const ZoomImageContainer = styled.div<{
  $height: number;
  $width: number;
  $fullWidth?: boolean;
}>`
  overflow: hidden;
  height: ${({ $height }) => $height}px;
  width: ${({ $width, $fullWidth }) =>
    $fullWidth
      ? "100%"
      : css`
          ${$width}px
        `};
`;

export const ZoomHoverStyle = css`
  ${ZoomImage} {
    transform: scale(1.1);
  }
`;

export const AnimatedUnderlineText = styled.span`
  background-image: linear-gradient(
    ${Core.surface.enabled},
    ${Core.surface.enabled}
  );
  background-size: 0 1px;
  background-position: 0 100%;
  background-repeat: no-repeat;
  transition: background-size 1000ms cubic-bezier(0.17, 0.67, 0.24, 1);
`;

export const UnderlineHoverStyle = css`
  ${AnimatedUnderlineText} {
    background-size: 100% 1px;
  }
`;
